<mat-progress-bar mode="indeterminate" style="width:400px;height:30px;"></mat-progress-bar>
<div *ngIf="info?.error" class="waiting-error">
    {{ info.error }}
</div>
<div *ngIf="info?.result" class="waiting-result">
    {{ info.result }}
</div>